import { useState, useEffect } from 'react';

/**
 * Lightweight hook to get the current Island user ID.
 * Fetches the user profile to get the ID without needing Stream connection.
 * @param {boolean} enabled - Whether to fetch the user ID (default: true)
 */
const useIslandUserId = (enabled = true) => {
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    if (!enabled) return;

    const fetchUserId = async () => {
      try {
        const response = await fetch('/island-api/v1/users/me/profile', {
          credentials: 'include',
        });

        if (response.ok) {
          const data = await response.json();
          setUserId(data.user_id);
        } else {
          console.error(
            'Failed to fetch user profile:',
            response.status,
            response.statusText
          );
        }
      } catch (e) {
        console.error('Failed to fetch user ID:', e);
      }
    };

    fetchUserId();
  }, [enabled]);

  return userId;
};

export default useIslandUserId;
